<template>
  <v-container fluid>
    <p class="display-1 mb-4">Regular Season Totals</p>
    <v-simple-table>
      <thead>
        <tr>
          <th class="text--white" v-for="head in regSeasonTotalsHeaders" :key="head.stat">{{ head.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in regSeasonTotalsRows" :key="i">
          <td v-for="(data, x) in row" :key="i + '---' + x">{{ data }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-spacer class="d-flex flex-grow-1 my-8" width="100%"></v-spacer>
    <p class="display-1 mb-4">Regular Season Per Game</p>
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="head in regSeasonPerGameHeaders" :key="head.stat">{{ head.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in regSeasonPerGameRows" :key="i">
          <td v-for="(data, x) in row" :key="i + '---' + x">{{ data }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-spacer class="d-flex flex-grow-1 my-8" width="100%"></v-spacer>
    <p class="display-1 mb-4">Post Season Totals</p>
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="head in postSeasonTotalsHeaders" :key="head.stat">{{ head.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in postSeasonTotalsRows" :key="i">
          <td v-for="(data, x) in row" :key="i + '---' + x">{{ data }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-spacer class="d-flex flex-grow-1 my-8" width="100%"></v-spacer>
    <p class="display-1 mb-4">Post Season Per Game</p>
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="head in postSeasonPerGameHeaders" :key="head.stat">{{ head.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in postSeasonPerGameRows" :key="i">
          <td v-for="(data, x) in row" :key="i + '---' + x">{{ data }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import config from "@/config";
import statsTableMixin from "@/mixins/statsTableMixin";

export default {
  name: "StatsTables",
  props: ["playerId"],
  mixins: [statsTableMixin],
  data() {
    return {
      careerHighs: null,
      regTotals: null,
      regPerGame: null,
      postSeasonTotals: null,
      postSeasonPerGame: null,
      error: null
    };
  },
  methods: {
    async getPlayerData() {
      const url = `${config.API}players/player/career/${this.playerId}`;
      try {
        const req = await fetch(url);
        const res = await req.json();

        this.careerHighs = res.career_highs;
        this.regTotals = res.regular_totals;
        this.regPerGame = res.regular_per_game;
        this.postSeasonTotals = res.post_season_totals;
        this.postSeasonPerGame = res.post_season_per_game;
      } catch (err) {
        this.error = "Failed to get player data!";
      }
    },
  },
  mounted() {
    this.getPlayerData();
  }
};
</script>